module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAOCAYAAAAWo42rAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAEASURBVCiR1cohS0NxGEbx8/zvHUxUUJNgs4pNZrM4k8WydUE/gEkMZgWLLOlkwSbOpFEWrINhscvWxCJrl+2+j9WwL+AvHo62j3qHiDNgDpgiCoyBKlBBFDbXOfI5pKEVD4IFzLpQCvkTa5zMPnCaQBURL/12/RbFM2jTUMtKv/bvdm9CfgKcA6Wd5gGmVpHJHYJcWRoDgBYNkfPHoL03Au6ZIc2K/240AsgBlByNxmM2Wl7ZIViTMPA10dKbPC6NSdgpzLjbbZYEB0iXNhdGzUF7a2LxI1uqHfeGwu8KdZyxgVlF2OHvpPRhuUFQzxFXoBMnWkABTDFIyoyrGJBav2xOcsB/m1DUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone-icon.png
// module id = g/mg
// module chunks = 1